import { render, staticRenderFns } from "./GSalaryReportView.vue?vue&type=template&id=5954eaaa&"
import script from "./GSalaryReportView.vue?vue&type=script&lang=js&"
export * from "./GSalaryReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports